/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/unbound-method, no-param-reassign */
import * as React from 'react';
import { TransitionProps } from 'react-transition-group/Transition';
import TransitionGroup from 'react-transition-group/TransitionGroup';

export interface PopupTransitionGroupProps {
  children: React.ReactElement<TransitionProps>[];
}

export class PopupTransitionGroup extends React.Component<PopupTransitionGroupProps> {
  static applyHeightLimitToPopup(elPopup: HTMLDivElement, maxHeight?: number): void {
    if (elPopup) {
      const limit = elPopup.firstElementChild ? elPopup.firstElementChild.clientHeight : 0;
      const maxh = maxHeight ?? limit;
      const minh = maxHeight ?? 0;
      elPopup.style.maxHeight = `${maxh}px`;
      elPopup.style.minHeight = `${minh}px`;
    }
  }

  private ref = React.createRef<HTMLDivElement>();

  private observer?: MutationObserver;

  private readonly isDesktopMQ =
    typeof window !== 'undefined' && window.matchMedia(`(min-width: 450px)`);

  public componentDidMount(): void {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener('resize', this.updateTransitions);

    if (typeof MutationObserver !== 'undefined') {
      this.observer = new MutationObserver(() => this.updateTransitions());
    }

    if (this.ref.current && this.observer) {
      this.observer.observe(this.ref.current, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
      });
    }

    this.updateTransitions();
  }

  public componentWillUnmount(): void {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateTransitions);
    }
    this.observer?.disconnect();
  }

  private updateTransitions(): void {
    const el = this.ref?.current;

    if (el) {
      if (this.isDesktopMQ && this.isDesktopMQ.matches) {
        const popups = el.childNodes;
        for (let i = 0; i < popups.length; i += 1) {
          PopupTransitionGroup.applyHeightLimitToPopup(popups[i] as HTMLDivElement);
        }
      } else {
        const popups = el.childNodes;
        let popupFirst: HTMLDivElement | null = null;
        for (let i = 0; i < popups.length; i += 1) {
          const popup = popups[i] as HTMLDivElement;
          if (popupFirst || popup.hasAttribute('data-exit')) {
            PopupTransitionGroup.applyHeightLimitToPopup(
              popup,
              popupFirst?.firstElementChild?.clientHeight,
            );
          } else {
            popupFirst = popup;
            PopupTransitionGroup.applyHeightLimitToPopup(popup);
          }
        }
      }
    }
  }

  public render(): React.ReactNode {
    const { children } = this.props;
    return (
      <div ref={this.ref}>
        <TransitionGroup component={null}>{children}</TransitionGroup>
      </div>
    );
  }
}
